import { FilterType, Filter, FilterKey, EApplicantOfferPGKeys } from 'api-paths-cas';
import { IGetFilterGroupsProps } from '..';
import { IDropdownOptionMulti } from '@/store/offers-dashboard/sagas/handleGetAllFilters';

const key = FilterKey.OFFER_STATUS;
export const getStatusFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter | null => {
  const filters = activeFilters[key] ?? [];
  let offerStatusFilterOptions: IDropdownOptionMulti[] = filterOptions?.[EApplicantOfferPGKeys.STATUS] || [];
  if (!offerStatusFilterOptions) {
    console.warn('Status filter options could not be extracted from filter options.');
    offerStatusFilterOptions = [];
  }

  const options = offerStatusFilterOptions?.map(status => {
    return {
      value: status.value,
      label: status.label,
      checked: filters.some(filter => status.value.some(stat => stat === filter)),
    };
  });

  const formattedOptions = {
    name: 'Offer Status',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY_MULTI: options,
    },
  };

  return formattedOptions;
};
